<template>
  <div>
    <SmartTitle
      heading="1"
      weight="medium"
    >
      Gateway BKO
    </SmartTitle>
    <div class="flex my-4 justify-between">
      <form class="spacing-input-search">
        <v-text-field
          v-model="search"
          append-icon="search"
          @keyup="findByRequestId"
          label="Buscar por request ID"
          single-line
          hide-details
        />
      </form>
    </div>
    <div v-if="!loading">
      <v-data-table
        :headers="headers"
        :items="list"
        class="my-4"
        :must-sort="true"
        @update:pagination="sort"
        hide-actions
      >
        <template v-slot:items="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.date }}</td>
          <td>{{ props.item.methods }}</td>
          <td>{{ props.item.status }}</td>
          <td class="force-text-black" width="100">
            <label
              @click="modelDownload(props.item.id)"
              class="flex flex-row align-center justify-center cursor-pointer"
            >
              <SmartIcon
                :size="2"
                name="download"
                class="mr-1-2"
                style="color: #F1F3F4;"
              />
              <span class="text-blue">Download</span>
            </label>
          </td>
          <td class="view-icon" width="100">
            <label
              @click="showInfo(props.item.id)"
              class="flex flex-row align-center justify-center cursor-pointer"
            >
              <SmartIcon
                :size="2"
                name="view"
                class="mr-1-2"
              />
            </label>
          </td>
        </template>
      </v-data-table>
      <div class="flex justify-center">
        <v-pagination
          v-if="currentPage"
          v-model="pagination.page"
          @input="changePage"
          :length="length"
          :value="currentPage"
          :total-visible="7"
          circle
        />
      </div>
    </div>
    <SmartCard class="mt-1 p-3" v-else>
      <SmartSkeletonLoading
        :items="11"
        :height="4"
      />
    </SmartCard>
    <div>
      <SmartDrawer
        @close="() => {showDrawer = false; gateway = null}"
        :show="showDrawer"
      >
        <template v-slot:header>
          <SmartTitle
            class="text-brand-secondary"
            weight="regular"
          >
            Detalhe de Gateway BKO
          </SmartTitle>
        </template>
        <InfoGateway v-if="gateway" :gateway="gateway" :gatewayDownloadFile="gatewayList"/>
      </SmartDrawer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { formatBRDateTime } from 'utils';
import moment from 'moment';
import { downloadCsvFile } from 'utils/blob';

export default {
  name: 'ListGateway',
  components: {
    InfoGateway: () => import('./InfoGateway')
  },

  data() {
    return {
      loading: false,
      search: '',
      gateway: null,
      showDrawer: false,
      pagination: {
        rowsPerPage: 10,
        page: 1
      },
      headers: [
        { text: 'Request ID', value: 'id', sortable: true },
        { text: 'Data', value: 'date', sortable: false },
        { text: 'Method', value: 'methods', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Retorno', sortable: false },
        { text: 'Detalhes', sortable: false }
      ],
      currentSort: {
        order: 'asc',
        sort: 'id'
      }
    };
  },
  methods: {
    ...mapActions({
      fetchGatewayList: 'gateway/fetchGatewayList',
      fetchGatewayListWithFilter: 'gateway/fetchGatewayListWithFilter'
    }),
    findByRequestId() {
      if (!this.search) return this.fetchGatewayList({ page: 1, sort: this.currentSort });
      return this.fetchGatewayListWithFilter({
        page: 1,
        filter: {
          request_id: this.search
        }
      });
    },
    changePage(page) {
      this.fetchGatewayList({ page, sort: this.currentSort }).then(() => {
        this.loading = false;
      });
    },
    showInfo(id) {
      const tempGateway = this.gatewayList.find(gateway => gateway.id === id);
      this.gateway = {
        id: tempGateway.id,
        date: formatBRDateTime(tempGateway.dataHoraRequisicao),
        methods: this.changeMethod(tempGateway.tipoRequisicao),
        status: this.changeStatus(tempGateway.statusRequisicao),
        route: tempGateway.route,
        payload: tempGateway.dadosEnviados

      };
      this.showDrawer = true;
    },
    modelDownload(id) {
      const data = this.gatewayList.find(gateway => gateway.id === id);
      const result = JSON.stringify(data);
      const currentDate = moment().format('MMMM Do YYYY, h:mm:ss a');
      downloadCsvFile({ filename: currentDate, file: result });
    },
    async sort(sortable) {
      const newSort = {
        order: sortable.descending ? 'desc' : 'asc',
        sort: sortable.sortBy
      };
      if (JSON.stringify(newSort) !== JSON.stringify(this.currentSort)) {
        this.currentSort = newSort;
        this.fetchGatewayList({ page: this.pagination.page, search: this.search, sort: this.currentSort });
      }
    },
    changeMethod(method) {
      if (method === 'POST') return 'Envio';
      if (method === 'GET') return 'Busca';
      if (method === 'PUT') return 'Edição';
      return method;
    },
    changeStatus(status) {
      if (status === '200') return 'Sucesso';
      if (status === '404') return 'Não Encontrado';
      if (status === '500') return 'Erro de Servidor';
      if (status === '422') return 'Não Processável';
      if (status === '400') return 'Sintaxe Incorreta';
      return status;
    }
  },
  computed: {
    ...mapGetters({
      gatewayList: 'gateway/gatewayList',
      gatewayListPagination: 'gateway/pagination'
    }),
    length() {
      return this.gatewayListPagination && this.gatewayListPagination.last_page;
    },
    currentPage() {
      return this.gatewayListPagination && this.gatewayListPagination.current_page;
    },
    list() {
      return (this.gatewayList
          && this.gatewayList.map(gateway => ({
            id: gateway.id,
            date: formatBRDateTime(gateway.dataHoraRequisicao),
            methods: this.changeMethod(gateway.tipoRequisicao),
            status: this.changeStatus(gateway.statusRequisicao)

          }))
      ) || [];
    }
  },
  async mounted() {
    this.loading = true;
    await this.fetchGatewayList({ sort: this.currentSort });
    this.loading = false;
  }
};
</script>

<style scoped>
</style>

<style lang="scss">
  .text-blue {
    color: #367BF5;
  }
</style>
